import properties from "./properties";
import sessionUtils from "./sessionUtils";
import httpClient from "./network/httpClient";
import { encode as base64encode } from "base64-arraybuffer";

const UAParser = require('ua-parser-js');

let currentStore;
const init = (store)=>{
  currentStore= store;
}
/******* OBJECT HELPERS ********/

import merge from "deepmerge";
import underscore from "underscore";

const thereAreDeepDifferences = (a,b)=>{
  return !underscore.isEqual(a,b);
}

const deepEqual = function (x, y) {
  const ok = Object.keys, tx = typeof x, ty = typeof y;
  return x && y && tx === 'object' && tx === ty ? (
    ok(x).length === ok(y).length &&
    ok(x).every(key => deepEqual(x[key], y[key]))
  ) : (x === y);
};

const isObjEmpty = function (obj): boolean {
  return Object.keys(obj).length === 0;
};

const returnIfExists = function (something) {
  if (something === undefined) {
    throw new Error("undefined");
  }
  return something;
};

/**
 * merge all the objects provided with priority
 * @param objects
 */
const mergeWithPriority = function (...objects): any {
  let merged = {};
  for (const obj of objects) {
    if (obj) {
      merged = merge(merged, obj);
    }
  }
  return merged;
};

/******* NOTIFICATIONS HELPERS ********/

const hideMessage = function () {
  currentStore.dispatch("clearMessage");
};

const dispatchMessage = function (message: any, time) {
  currentStore.dispatch("showMessage", message);
  if(time){
    setTimeout(() => {
      hideMessage();
    }, time);
  }
};

/**
 * Show message at the top of the screen
 * 
 * @param type type of message to show
 * @param content the message to show
 * @param time time in milliseconds the message will be displayed, defaults to properties.TIMEOUT_NOTIFICATIONS: if set to 0 message will not disappear unless user clicks to close it
 */
const showMessage = function (
  type: "ERROR" | "WARNING" | "SUCCESS" | "INFO",
  content: string,
  time: number = properties.TIMEOUT_NOTIFICATIONS
) {
  dispatchMessage({ type: type, content: content, prefix: null, suffix: null, click: null }, time);
};

const showBirthdayMessage = function () {
  setTimeout(() => {
    dispatchMessage({ type: "BIRTHDAY", content: currentStore.getters.translate('happy_birthday'), prefix: null, suffix: null, click: null },null);
  }, 1000);
};

const showMessageWithLink = function (
  type: "ERROR" | "WARNING" | "SUCCESS" | "INFO",
  prefix: string,
  link: string,
  suffix: string,
  click: Function
) {
  dispatchMessage({ type: type, content: link, prefix, suffix, click }, properties.TIMEOUT_NOTIFICATIONS_WITH_LINK);
};

/******* COMPONENT ACTION HELPERS ********/

const getComponentAction = function () {
  return currentStore.getters.getComponentAction;
}

const setComponentAction = function (
  action: string,
  options: Object = {}
) {
  currentStore.dispatch(
    "setupComponentAction",
    {
      action: action,
      options: options
    }
  );
}

const clearComponentAction = function () {
  currentStore.dispatch("clearComponentAction");
}

/******* SCROLL HELPERS ********/

/**
 * Scrolls to the element with the provided id
 *
 * @param elementId The id of the element to scroll to
 * @param yOffset Additional negative yOffset, default is -10
 *
 * @usageNotes If the function logs "no element found", try using this function during or after the mounted hook,
 * or try to call it using a setTimeout(() => ...code here, 0) or a Promise.resolve().then(() => ...code here).
 * See more about "JS micro and macro tasks", to understand the differences between these two methods
 */
const scrollTo = function (elementId, yOffset = -10) {
  const headerId = 'nav-container_mobile';

  const element = document.getElementById(elementId);
  const header = document.getElementById(headerId);

  const headerHeight = header?.offsetHeight ?? 0;
  yOffset = yOffset - headerHeight;

  const y = element ? element.getBoundingClientRect().top + window.pageYOffset + yOffset : 0;

  if(!element) {
    console.log("oneUtils.utils.scrollTo(): no element with id '" + elementId + "' found");
  }
  else {
    // Use this function for accessibility reasons: automatically set focus on the first visible element on the view you are scrolling to
    element.scrollIntoView({behavior: "smooth", block: "start"});
  }

  window.scrollTo({top: y, behavior: 'smooth'});
}

/******* LOADERS HELPERS ********/

let loaders = 0;

const hideGlobalLoader = function () {
  if (loaders>0)loaders--;
  if(loaders==0){
    const loader = document.getElementById("global-loader-overlay");
    if (loader) {
      loader.style.display = "none";
    }
  }
};

const showGlobalLoader = function () {
  loaders++;
  window.scrollTo(0, 0);
  const loader = document.getElementById("global-loader-overlay");
  if (loader) {
    loader.style.display = "flex";
  }
};

const hideLeftLoader = function () {
  const leftLoader = document.getElementById("left-loader-overlay");
  if (leftLoader) {
    leftLoader.style.display = "none";
  }
  hideGlobalLoader();
};

const showLeftLoader = function () {
  hideMessage();
  const leftLoader = document.getElementById("left-loader-overlay");
  if (leftLoader) {
    leftLoader.style.display = "flex";
  }
};




const getSalutationsFromServer = function(){
  return httpClient.getSalutations().then((data: any) => {
    return getSalutationsByCurrentLanguage(data.data.valuelists['businessPartner.salutation']);
  })
  .catch((err) => {
    return [];
  });
}

const getGendersFromServer = function(){
  return httpClient.getGenders().then((data: any) => {
    return getGendersByCurrentLanguage(data.data.valuelists['businessPartner.gender']);
  })
  .catch((err) => {
    return [];
  });
}

const getNationalitiesFromServer = function(){
  return httpClient.getNationalities().then((data: any) => {
    return getNationalitiesByCurrentLanguage(data.data.valuelists['businessPartner.nationalityISO']);
  })
  .catch((err) => {
    return [];
  });
}

const getSalutationsByCurrentLanguage = function(salutations){
  const salutationsToReturn: any = [];
  for (const salutation of salutations) {
    const rightTranslation = salutation.labels.find((l)=>{
      return l.label;
    })
    if(rightTranslation){
      salutationsToReturn.push(
        {
          label:rightTranslation.label,
          value:salutation.apiKey
        }
      );
    }
  }
  return salutationsToReturn;
}

const getGendersByCurrentLanguage = function(genders){
  const gendersToReturn: any = [];
  for (const gender of genders) {
    const rightTranslation = gender.labels.find((l)=>{
      return l.label;
    })
    if(rightTranslation){
      gendersToReturn.push(
        {
          label:rightTranslation.label,
          value:gender.apiKey
        }
      );
    }
  }
  return gendersToReturn;
}

const getNationalitiesByCurrentLanguage = function(nationalities){
  const nationalitiesToReturn: any = [];
  for (const nationality of nationalities) {
    const rightTranslation = nationality.labels.find((l)=>{
      return l.label;
    })
    if(rightTranslation){
      nationalitiesToReturn.push(
          {
            label:rightTranslation.label,
            value:nationality.apiKey
          }
      );
    }
  }
  return nationalitiesToReturn;
}

const getRegionCodesFromServer = function(country: string){
  showGlobalLoader();
  return httpClient.getRegionCodes(country).then((data: any) => {
    hideGlobalLoader();
    if(data?.data?.valuelists && data.data.valuelists[`address.countryRegion.${country}`]) {
      return data.data.valuelists[`address.countryRegion.${country}`];
    }
    return [];
  })
    .catch((err) => {
      hideGlobalLoader();
      return [];
    });
}

const getRegionCodesByCurrentLanguage = function(values){
  const options: any = [];
  for (const value of values) {
    const rightTranslation = value.labels.find((l)=>{
      return l.label;
    })
    if(rightTranslation){
      options.push(
        {
          label: rightTranslation.label,
          value: value.apiKey.split('-')[1]
        }
      );
    }
  }
  return options;
}

const sortUsageText = (textBlockForLang)=>{
  textBlockForLang.usageText = textBlockForLang.usageText.sort(
    (a,b)=>{
      if(a.ordinalNumber && b.ordinalNumber){
        if (a.ordinalNumber < b.ordinalNumber) return -1;
        if (a.ordinalNumber > b.ordinalNumber) return 1;
      }
      return 0;
    }
  );
  return textBlockForLang;
}

const sortUsageDefinitions = (textBlockForLang)=>{
  textBlockForLang.usageDefinitions = textBlockForLang.usageDefinitions.sort((a,b)=>{
    if(a.ordinalNumber && b.ordinalNumber){
      if (a.ordinalNumber>b.ordinalNumber) return 1;
      if (a.ordinalNumber<b.ordinalNumber) return -1;
    }
    return 0;
  });
  return textBlockForLang;
}

const sortTextBlock = (textBlockForLang)=>{
  if(textBlockForLang.usageText){
    textBlockForLang = sortUsageText(textBlockForLang);
  }
  if(textBlockForLang.usageDefinitions){
    sortUsageDefinitions(textBlockForLang);
  }
}

const  generateCodeChallenge = async function(codeVerifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  const base64Digest = base64encode(digest);
  // you can extract this replacing code to a function
  return base64Digest
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

}
const replacePasswordCharacters = function(pass){
  return pass ? pass.replace('‘',"'").replace('’',"'").replace('`',"'").replace('“','"').replace('”','"') : null;
}


const getBrandAndDarkModeClasses = ()=>{
  const _cssReference = currentStore.getters.configure('_cssReference') || properties.DEFAULT_FALLBACK_CSS_REFERENCE;
  let toReturn = '';
  switch (_cssReference) {
    case 'mini':
      toReturn =  '__m ';
      break;
    case 'toyota':
      toReturn = '__t ';
      break;
    case 'alphera':
      toReturn = '__alphera ';
      break;
    case 'alphabet':
      toReturn = '__alphabet ';
      break;
    case 'rr':
      toReturn = '__rr';
      break;
    case 'motorrad':
      toReturn = '__motorrad';
      break;
    default:
      toReturn = '__b'
      break;
  }
  const brand = currentStore.state.configurationParams.brand;

  if(sessionUtils.getParameterByName(window.location.href,"isDarkmode")=="true" || (sessionUtils.getParameterByName(window.location.href,"isDarkmode")!="false" && window.localStorage.getItem("oneid_darkmode_selected_"+brand)=="true")){
    toReturn+= ' __d ';
  }

  return toReturn;
};


/**
* collects all the query parameters from the url provided inside an object
* @param url
*/
const getQueryParams = (url: string = window.location.href): any =>{
  const queryParams = {};
  if (url.indexOf("?") >= 0) {
    for (const elem of url.substring(url.indexOf("?") + 1).split("&")) {
      const pair = elem.split("=");
      let toAdd = "";
      if(pair.length>2){
        for (let index = 2; index < pair.length; index++) {
          const element = '='+pair[index];
          toAdd = toAdd+element;
        }
      }
      queryParams[pair[0]] = decodeURIComponent(pair[1])
        ? decodeURIComponent(pair[1])+toAdd
        : "";
    }
  }
  return queryParams;
}

const storeParametersToLocalStorage = (query: any) => {
  const newquery = {...query}
  delete newquery.redirectFrom;
  delete newquery.register_first;
  delete newquery.permanent;
  window.localStorage.setItem("storedParameters", JSON.stringify(newquery));
}

const recoveryParametersFromLocalStorage = () => {
  const query = getQueryParams(window.location.href);
  const savedParametersString = window.localStorage.getItem("storedParameters");

  if (savedParametersString) {
    const savedParameters = JSON.parse(savedParametersString);
    const savedParametersEncoded = {};

    for (const key in  savedParameters) {
      savedParametersEncoded[key] = decodeURIComponent(savedParameters[key])==savedParameters[key] ? encodeURIComponent(savedParameters[key]) : savedParameters[key];
    }
    const newParameters = { ...savedParametersEncoded, ...query };
    replaceQueryParams(newParameters);
  }
}

const replaceQueryParams = (params) => {
  let queryString = "";
  const redirecturi = params.redirect_uri;
  delete params.redirect_uri;
  for (const k in params) {
    queryString = queryString.concat(`&${k}=${params[k]}`);
  }
  if (queryString) {
    if (redirecturi)queryString = queryString+"&redirect_uri="+(decodeURIComponent(redirecturi)==redirecturi ? encodeURIComponent(redirecturi) :redirecturi);
    queryString = "?" + queryString.substring(1);
    let hash = window.location.hash;
    if (hash.indexOf("?") != -1) {
      hash = hash.substring(0, hash.indexOf("?"));
    }
    window.location.hash = hash + queryString;
  }
}

const removeURLParameter = (url, parameter)=> {
  //prefer to use l.search if you have a location/link object
  var urlparts = url.split('?');
  if (urlparts.length >= 2) {
      const first = urlparts[0];
      urlparts.shift();
      const rest = urlparts.join('?');
      var prefix = encodeURIComponent(parameter) + '=';
      var pars = rest.split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
          //idiom for string.startsWith
          if (pars[i].lastIndexOf(prefix, 0) !== -1) {
              pars.splice(i, 1);
          }
      }
      return first + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

const updateQueryParams = (params) => {
  // 1. replace query params
  replaceQueryParams(params);
  // 2. update stored params
  const stored = window.localStorage.getItem("storedParameters");
  if (stored) {
    storeParametersToLocalStorage(params);
  }
}
/**
 * @param key
 * @param value
 */
const updateQueryParamsByKey = (key, value) => {
  const query = getQueryParams(window.location.href);
  query[key] = value;
  updateQueryParams(query);
}

const hideConsoleLogInByEnvironment = () => {
  let allowedLogsTypes = process.env.VUE_APP_ALLOWED_LOG_TYPES;
  allowedLogsTypes = allowedLogsTypes.split(",").map(e => e.trim());
  if (!allowedLogsTypes.includes("log")) console.log = function(){
    // do nothing
  };
  if (!allowedLogsTypes.includes("info")) console.info = function(){
    // do nothing
  };
  if (!allowedLogsTypes.includes("debug")) console.debug = function(){
    // do nothing
  };
  if (!allowedLogsTypes.includes("warn")) console.warn = function(){
    // do nothing
  };
  if (!allowedLogsTypes.includes("error")) console.error = function(){
    // do nothing
  };
};

/**
 * Capitalizes first letter of the provided string and returns the changed string
 */
const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const loadScript = (src, type = "") => {
  return new Promise(function (resolve, reject) {
    let shouldAppend = false;
    let el: HTMLScriptElement | null;
    el = document.querySelector('script[src="' + src + '"]');
    if (!el) {
      el = document.createElement('script');
      el.async = true;
      el.src = src;
      if(type) {
        el.type = type;
      } else {
        el.type = 'text/javascript';
      }
      shouldAppend = true;
    }
    else if (el.hasAttribute('data-loaded')) {
      resolve(el);
      return;
    }

    el.addEventListener('error', reject);
    el.addEventListener('abort', reject);
    el.addEventListener('load', function loadScriptHandler() {
    if(el)
      el.setAttribute('data-loaded', 'true');
      resolve(el);
    });

    if (shouldAppend) document.head.appendChild(el);
  });
};

const getNavigatorInstance = function getNavigatorInstance() {
  if (typeof window !== 'undefined') {
      if (window.navigator || navigator) {
          return window.navigator || navigator;
      }
  }

  return false;
};

const isIOS13Check = function isIOS13Check(type) {
  var nav = getNavigatorInstance();
  return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window['MSStream']);
};

const isAndroid = () =>{
  var UA = new UAParser();
  var os = UA.getOS();
  return os.name === "Android";
}
const isMobile = () =>{
  var UA = new UAParser();
  var device = UA.getDevice();
  switch (device.type) {
    case "mobile":
    case "tablet":
      return true;
    default:
      return false || isIOS13Check('iPad');
  }
}
const isIOS = () =>{
  var UA = new UAParser();
  var os = UA.getOS();
  return os.name === "iOS" || isIOS13Check('iPad');
}
const getOsVersion = () =>{
  var UA = new UAParser();
  var os = UA.getOS();
  return os.version;
}
const isBrowser = () =>{
  var UA = new UAParser();
  var device = UA.getDevice();
  return device.type === undefined;
}




export default {
  getOsVersion,
  isMobile,
  isIOS,
  isBrowser,
  isAndroid, 

  init,

  getBrandAndDarkModeClasses,

  thereAreDeepDifferences,

  generateCodeChallenge,

  replacePasswordCharacters,

  sortTextBlock,

  getRegionCodesByCurrentLanguage,

  getRegionCodesFromServer,

  getSalutationsByCurrentLanguage,

  getGendersByCurrentLanguage,

  getSalutationsFromServer,

  getGendersFromServer,

  getNationalitiesFromServer,

  getNationalitiesByCurrentLanguage,

  showMessage,

  showMessageWithLink,

  getComponentAction,

  setComponentAction,

  clearComponentAction,

  scrollTo,

  showBirthdayMessage,

  hideMessage,

  hideLeftLoader,

  showLeftLoader,

  showGlobalLoader,

  hideGlobalLoader,

  mergeWithPriority,

  returnIfExists,

  isObjEmpty,

  deepEqual,

  getQueryParams,
  storeParametersToLocalStorage,
  recoveryParametersFromLocalStorage,
  replaceQueryParams,
  updateQueryParams,
  updateQueryParamsByKey,
  removeURLParameter,
  hideConsoleLogInByEnvironment,
  capitalizeFirstLetter,
  loadScript
};
